import { d as __rest, c as __read, _ as __assign, e as __spreadArray } from './chunks/tslib.es6-ebb56484.js';
import React__default, { useState } from 'react';
import { useIsMobile } from '@sravni/react-utils';
import { ACTIONS_LIST, INSURANCE_DEFAULT_TABS_ORDER } from '@sravni/ugc/lib/specialOffers/lists';
import { S as SpecialOffers } from './chunks/SpecialOffers-a6f847de.js';
import './chunks/UltimateSpecialOffers-41b10559.js';
import './chunks/index-9d6795ea.js';
import '@sravni/ugc/lib/specialOffers/helpers';
import '@sravni/react-design-system';
import './chunks/getTitle-6237901b.js';
import '@sravni/react-design-system/lib/Space';
import './chunks/isEqual-9167b1e9.js';
import './chunks/_baseIsEqual-16f30e0a.js';
import './chunks/isTypedArray-a816ffbf.js';
import 'crypto';
import './chunks/Preloader-30f97917.js';

var SpecialOffersForInsurance = function (_a) {
    var _b = _a.maxDesktopVisibleItems, maxDesktopVisibleItems = _b === void 0 ? undefined : _b, props = __rest(_a, ["maxDesktopVisibleItems"]);
    var isMobile = useIsMobile();
    var _c = __read(useState(), 2), activeTab = _c[0], setActiveTab = _c[1];
    var _d = __read(useState(ACTIONS_LIST), 2), tabs = _d[0], setTabs = _d[1];
    var _e = __read(useState('0px'), 2), actionsHeight = _e[0], setActionsHeight = _e[1];
    var handleSetActionsItemsCount = function (count) {
        if (tabs === ACTIONS_LIST) {
            if (!(count && ((isMobile && count > 0) || (!isMobile && count > 2)))) {
                setActiveTab(INSURANCE_DEFAULT_TABS_ORDER[0]);
                setTabs(__spreadArray([], __read(INSURANCE_DEFAULT_TABS_ORDER), false));
            }
            setActionsHeight('auto');
        }
    };
    return (React__default.createElement("div", { style: { height: actionsHeight, overflow: 'hidden' } },
        React__default.createElement(SpecialOffers, __assign({}, props, { tabs: tabs, activeTab: activeTab, setItemsCount: handleSetActionsItemsCount, maxDesktopVisibleItems: tabs === ACTIONS_LIST ? 4 : maxDesktopVisibleItems }))));
};

export { SpecialOffersForInsurance };
//# sourceMappingURL=SpecialOffersForInsurance.esm.js.map
